export enum RecipientType {
    WORKER = "Worker",
    CLIENT = "Client",
    INTERNAL = "Internal"
}

export enum ReminderType {
    REGULAR = "Regular",
    ESCALATION = "Escalation",
    BASE_TEMPLATE = "BaseTemplate"
}

export enum PreviewType {
    REMINDER = "Reminder",
    ESCALATION = "Escalation"
}

export enum NotificationEntityType {
    TIMESHEET = "Timesheet",
    EXPENSE_CLAIM = "ExpenseClaim",
    TIMESHEET_EXPENSE = "Timesheet_Expense"
}

export enum ReminderRecipientGroupCodes {
    AllWorkers = "AllWorkers",
    OnlineTimesheetWorkers = "OnlineTimesheetWorkers",
    OfflineTimesheetWorks = "OfflineTimesheetWorkers",
    VmsTimesheetWorkers = "VmsTimesheetWorkers",
    OnlineTimesheetApprovers = "OnlineTimesheetApprovers",
    OnlineExpenseApprovers = "OnlineExpenseApprovers",
}

export enum ReminderTriggerPeriod {
    BeforePeriodEnds = "BeforePeriodEnds",
    AfterPeriodEnds = "AfterPeriodEnds",
    AfterSubmission = "AfterSubmission"
}

export enum EscalationRecipientRole{
    AssignedTo = "WorkOrder.AssignedTo",
    JobOwner = "WorkOrder.JobOwner",
    Recruiter = "WorkOrder.Recruiter"
}

export enum ReminderCategory{
    TimesheetSubmissionOverdueReminder = "TimesheetSubmissionOverdueReminder",
    TimesheetApprovalOverdueReminder = "TimesheetApprovalOverdueReminder",
    ExpenseApprovalOverdueReminder = "ExpenseApprovalOverdueReminder",
    TimesheetAndExpenseApprovalOverdueReminder = "TimesheetAndExpenseApprovalOverdueReminder",
}

export enum EditMessageContext {
    Create = "create",
    Edit = "edit"
}

export enum PreferredLanguage {
    English = "en",
    French = "fr"
}

export enum PreferredCultureId {
    English = 48,
    French = 88
}

export enum TemplateSaveAction {
    SaveChanges = "SaveChanges",
    SaveAsNew = "SaveAsNew"
}

export enum BaseTemplateTags {
    subject = "{{subject}}",
    content = "{{content}}",
    supportEmail = "{{SupportEmail}}",
}

// Platform support address: templates carry it literally as their default footer address, so it is also the
// token swapped for the tenant's configured FeedbackEmailAddress (same rule the reminder processor applies).
export const DEFAULT_SUPPORT_EMAIL = "contact@gorillaworks.io"